<section class="inner-page-section">
    <div class="container">
        <!-- <table>
            <tr>
                <td>
                    <div style="width: 700px;height: 600px;" id="dib-posts">
                       </div>
                </td>
                <td></td>
                <td>
                    <div style="width: 300px;height: 600px;">
                        <h4>Recent Posts</h4>
                        <div id="dib-recent-post-list"></div>
                        <h4>Categories</h4>
                        <div id="dib-categories"></div>
                    </div>
                </td>
            </tr>
           </table> -->


        <table>
            <tr>
                <td>
                    <div class="leftDiv" id="dib-posts"></div>
                </td>
                <td class="midDiv"></td>
                <td valign="top">
                    <div class="rightDiv">
                        <h4>Recent Posts</h4>
                        <div id="dib-recent-post-list"></div>
                        <!-- <h4>Categories</h4>
                        <div id="dib-categories"></div> -->
                    </div>
                </td>
            </tr>
           </table>
        <!-- <div class="leftDiv" id="dib-posts"></div>
        <div class="rightDiv">
            <h2>Recent Posts</h2>
            <div id="dib-recent-post-list"></div>
            <h2>Categories</h2>
            <div id="dib-categories"></div>
        </div> -->
    </div>    
</section>
